const emailTemplates = {
  infoBannerTitle: "Шаблоны email управляются в Supabase Auth",
  infoBannerDesc: "Изменения там немедленно повлияют на все системные письма.",
  openInSupabase: "Открыть шаблоны email в Supabase",
  authEmailsTitle: "Письма аутентификации",
  confirmSignUp: "Подтверждение регистрации",
  confirmSignUpDesc: "Отправляется после создания аккаунта для подтверждения email.",
  inviteUser: "Приглашение пользователя",
  inviteUserDesc: "Приглашение при добавлении пользователя в систему.",
  magicLink: "Быстрый вход",
  magicLinkDesc: "Вход без пароля — одноразовая ссылка на email.",
  changeEmail: "Смена email",
  changeEmailDesc: "Подтверждение при смене email адреса.",
  resetPassword: "Сброс пароля",
  resetPasswordDesc: "Отправляется при нажатии 'Забыли пароль'.",
  reauthentication: "Повторная аутентификация",
  reauthenticationDesc: "Подтверждение перед выполнением важных действий.",
  securityEmailsTitle: "Письма безопасности",
  passwordChanged: "Пароль изменён",
  passwordChangedDesc: "Уведомление при смене пароля.",
  emailChanged: "Email изменён",
  emailChangedDesc: "Уведомление при смене email адреса.",
  phoneChanged: "Телефон изменён",
  phoneChangedDesc: "Уведомление при смене номера телефона.",
  identityLinked: "Провайдер подключён",
  identityLinkedDesc: "Уведомление при подключении провайдера (Google / OAuth).",
  identityUnlinked: "Провайдер отключён",
  identityUnlinkedDesc: "Уведомление при отключении провайдера.",
  mfaAdded: "MFA включён",
  mfaAddedDesc: "Уведомление при включении двухфакторной аутентификации.",
  mfaRemoved: "MFA отключён",
  mfaRemovedDesc: "Уведомление при отключении двухфакторной аутентификации.",
  variablesTitle: "Динамические переменные",
  varConfirmationUrl: "Ссылка подтверждения/действия",
  varSiteUrl: "URL сайта",
  varEmail: "Email пользователя",
  customizationTitle: "Параметры настройки",
  customSubject: "Тема письма",
  customHtml: "HTML тело и текст",
  customLayout: "Адаптивный дизайн и макет",
  customCta: "Кнопка призыва к действию",
  customRtl: "Поддержка RTL",
  customBrand: "Логотип и цвета бренда",
} as const;
export default emailTemplates;
